








































































































































































import BaseComponent from '@/components/base-component.vue';
import UiAutocompleteSubordinate from '@/components/UI/autocomplete-subordinate.vue';
import UiDatePickerRange from '@/components/UI/date-picker-range.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import UiTimePicker from '@/components/UI/time-picker.vue';
import { ConflitoAgendaFiltros } from '@/interfaces/calendar';
import { ItemAgendaParmDTO } from '@/interfaces/crm-planner';
import * as service from '@/services/crm-planner';
import { Observable } from 'rxjs';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import CalendarConflictAlertDialog from '../calendar/calendar-conflict-alert-dialog.vue';

@Component({
  components: {
    UiDatePicker,
    UiDatePickerRange,
    UiAutocompleteSubordinate,
    UiTimePicker,
    CalendarConflictAlertDialog
  }
})
export default class PlannerItemForm extends BaseComponent {
  @Prop()
  id: number;

  @Prop({ default: false })
  edit: boolean;

  @Prop()
  date: string;

  modalOpen = false;
  dto: any = {
    dataIni: null
  };

  typesLoading = false;
  types = [];
  typeSelected = null;

  durationHours = null;
  datesSelected = [];

  conflictParms: ConflitoAgendaFiltros = null;
  formConflictOpened = false;

  public form: any = {
    valid: false,
    rules: {
      tipo: [(v) => v != null || 'Selecione a Tipo'],
      titulo: [(v) => v != null || 'Informe o Título'],
      colaborador: [(v) => v != null || 'Selecione o Colaborador'],
      colaboradores: [(v) => (v != null && v.length > 0) || 'Selecione pelo menos um Colaborador'],
      presencial: [(v) => v != null || 'Selecione a Modalidade'],
      descricaoLocal: [(v) => v != null || 'Informe o local'],
      data: [(v) => this.validDate(v)],
      horaIni: [(v) => (!!v && v.length == 5) || 'Informe um horário válido'],
      horaFim: [(v) => (!!v && v.length == 5) || 'Informe um horário válido']
    }
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  mounted() {
    if (!this.id) {
      this.modalOpen = true;
    }
    this.loadTypes();
  }

  loadTypes() {
    this.typesLoading = true;
    service.listCrmPlannerItemTypes().subscribe(
      (res) => {
        this.typesLoading = false;
        this.types = res;
        if (this.id) {
          this.loadItemDetails();
        }
      },
      (error) => {
        this.typesLoading = false;
        this.showToastApiError(error);
      }
    );
  }

  @Watch('id', { immediate: true })
  onIdChange(id) {
    if (!id) {
      return;
    }
    if (this.types && this.types.length > 0) {
      this.loadItemDetails();
    }
  }

  @Watch('date', { immediate: true })
  onDateChange(date) {
    this.dto.dataIni = date;
    this.datesSelected = [date, date];
  }


  loadItemDetails() {
    this.loader.start('Carregando ...');
    service.detailCrmPlannerItem(this.id).subscribe(
      (res) => {
        this.dto = { ...res };
        this.typeSelected = this.types.find((t) => t.id == res.idTipo);
        this.durationHours = !res.dias;
        this.datesSelected = [res.dataIni, res.dataFim];
        this.dto.idsParticipantes = this.typeSelected.individual ? res.idsParticipantes[0] : res.idsParticipantes;
        this.modalOpen = true;
        this.loader.stop();
      },
      (error) => {
        this.showToastApiError(error);
        this.close();
        this.loader.stop();
      }
    );
  }

  onTypeChange(t) {
    if (!t) {
      this.durationHours = null;
      return;
    }

    setTimeout(() => {
      try {
        this.$refs['tfTitulo'].focus();
      } catch (e) {}
    }, 300);

    if (t.unidadeDuracao.horas && t.unidadeDuracao.dias) {
      this.durationHours = null;
      return;
    }

    this.durationHours = t.unidadeDuracao.horas;
  }

  public close(): void {
    this.$emit('close');
  }

  public save() {
    this.$refs.form.validate();

    if (!this.form.valid) {
      return;
    }

    let parm = this.prepareParms();

    let obs: Observable<any> = null;
    if (this.dto.id) {
      parm.id = this.dto.id;
      obs = service.updateCrmPlannerItem(parm);
    } else {
      obs = service.saveCrmPlannerItem(parm);
    }
    this.loader.start('Processando ...');
    obs.subscribe(
      (res) => {
        this.loader.stop();
        this.toast.show('Registro salvo com sucesso', 'success');
        this.$emit('afterSave', res);
      },
      (error) => {
        this.showToastApiError(error);
        this.loader.stop();
      }
    );
  }

  prepareParms() {
    let parm = new ItemAgendaParmDTO();
    parm.idTipo = this.typeSelected.id;
    parm.titulo = this.dto.titulo;
    parm.idsParticipantes = this.dto.idsParticipantes.length ? this.dto.idsParticipantes : [this.dto.idsParticipantes];
    parm.descricaoLocal = this.dto.descricaoLocal;
    parm.presencial = this.dto.presencial;
    parm.dias = !this.durationHours;
    if (this.durationHours) {
      parm.dataIni = this.dto.dataIni;
      parm.dataFim = null;
      parm.horaIni = this.dto.horaIni;
      parm.horaFim = this.dto.horaFim;
    } else {
      parm.dataIni = this.datesSelected && this.datesSelected.length ? this.datesSelected[0] : this.datesSelected;
      parm.dataFim =
        this.datesSelected && this.datesSelected.length && this.datesSelected.length > 1 ? this.datesSelected[1] : null;
      parm.horaIni = null;
      parm.horaFim = null;
    }
    parm.observacao = this.dto.observacao;
    return parm;
  }

  preSave() {
    this.$refs.form.validate();

    if (!this.form.valid) {
      return;
    }

    let parm = this.prepareParms();

    this.conflictParms = new ConflitoAgendaFiltros();
    this.conflictParms.tipoAlterando = 'EA';
    this.conflictParms.idAlterando = this.dto.id;
    this.conflictParms.dataIni = parm.dataIni;
    this.conflictParms.dataFim = parm.dataFim;
    this.conflictParms.horaIni = parm.horaIni;
    this.conflictParms.horaFim = parm.horaFim;
    this.conflictParms.idsLogins = parm.idsParticipantes;

    this.formConflictOpened = true;      
  }

  onReturnSave() {
    this.formConflictOpened = false;
    this.save();
  }

  onReturnCancel() {
    this.formConflictOpened = false;
  }

  validDate(v) {
    if (!v) {
      return 'Informe uma data válida';
    }
    return true;
  }
}
